/**重置message，防止重复点击重复弹出message弹框 */
import {Message} from 'element-ui';

// 检测当前是否为移动端：优先使用路由守卫/sessionStorage 中写入的标记，再按 UA/屏宽兜底
function isMobile() {
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const cached = window.sessionStorage.getItem('isMobile');
      if (cached === 'true' || cached === 'false') return cached === 'true';
    }
  } catch (e) {}
  if (typeof window !== 'undefined' && window.navigator) {
    const ua = window.navigator.userAgent || '';
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
      || (window.innerWidth || 9999) <= 520;
  }
  return false;
}

let messageInstance = null;
const resetMessage = (options) => {
    if(messageInstance) {
        messageInstance.close()
    }

    // 移动端统一使用更友好的弹窗样式
    if (isMobile()) {
      const cls = options.customClass ? options.customClass + ' mobile-message' : 'mobile-message';
      options = {
        ...options,
        customClass: cls,
        // 移动端隐藏关闭按钮，避免与触控区域冲突；若调用方显式设置则尊重调用方
        showClose: typeof options.showClose === 'boolean' ? options.showClose : false,
        offset: options.offset || 20
      };
    }

    messageInstance = Message(options)
};
['error','success','info','warning'].forEach(type => {
    resetMessage[type] = options => {
        if(typeof options === 'string') {
            options = {
                message:options
            }
        }
        options.type = type
        return resetMessage(options)
    }
})
export const message = resetMessage



// WEBPACK FOOTER //
// ./src/commonJs/ResetMessage.js